import styled from '@emotion/styled'

import { getHeaderCellStyles } from '../../../../../../reports/utils/getHeaderCellStyles'

export const HeaderCell = styled.th`
  ${getHeaderCellStyles()}
`
